import { useEffect, useMemo, useState } from "react";
import type { DeptItem, OperationEvent } from "../type";

export function useModalBody(
  searchedList: DeptItem[],
  eventType: OperationEvent,
) {
  const [pendingDepts, setPendingDepts] = useState<DeptItem[]>(searchedList);

  const radioOptions = useMemo(
    () =>
      pendingDepts.map((dept) => ({
        label: dept.deptName,
        value: dept.deptNo,
      })),
    [pendingDepts],
  );

  useEffect(() => {
    if (searchedList && eventType === "search") {
      setPendingDepts(searchedList);
    }
  }, [searchedList, eventType]);

  return {
    pendingDepts,
    setPendingDepts,
    radioOptions,
  };
}
